import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { catchError, Observable, throwError } from 'rxjs';
import { DvSnackbarService } from '@devinco/ui/dds/snackbar';
import { HttpErrorModel } from '@core/interfaces/http-error';
import { SnackBarConfig } from '@shared/constants/snackbar-config';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  private snackBar = inject(DvSnackbarService);
  private translate = inject(TranslateService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((resp: { error: any | HttpErrorModel }) => {
        this.snackBar.open(this.getErrorMessage(resp?.error), {
          ...SnackBarConfig.Error,
          multiline: true,
        });
        return throwError(() => resp);
      }),
    );
  }

  private getErrorMessage(error?: HttpErrorModel): string {
    if (error?.textId) return this.translate.instant(error.textId);

    if (error?.message) return error.message;

    return this.translate.instant('General.Error');
  }
}
